import { render, staticRenderFns } from "./DistributionOrderList.vue?vue&type=template&id=0cd5b9f7&scoped=true&"
import script from "./DistributionOrderList.vue?vue&type=script&lang=js&"
export * from "./DistributionOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5b9f7",
  null
  
)

export default component.exports